// src/modules/comission/components/Modals/ModalConfirmExport.tsx
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress, Stack } from "@mui/material";
import { useState } from "react";
import { ComissionServices } from "../../../../shared/services/api/comission/ComissionServices";
import { useExportComissionExcel } from "../../hooks/useExportComissionExcel";
import { useExportComissionPDF } from "../../hooks/useExportComissionToPDF";

interface Props {
	open: boolean;
	onClose: () => void;
	comissionId: string;
	clientName: string;
	dataIni: string;
	dataFim: string;
	exportType: "excel" | "pdf"; // 👈 nova prop!
}

export const ModalConfirmExport = ({ open, onClose, comissionId, clientName, dataIni, dataFim, exportType }: Props) => {
	const [loading, setLoading] = useState(false);
	const { exportComissionToExcel } = useExportComissionExcel(setLoading);
	const { exportComissionToPDF } = useExportComissionPDF(setLoading); // 👈 seu novo hook para PDF

	const handleExport = async () => {
		setLoading(true);
		try {
			const result = await ComissionServices.getComissionValuesDetail(comissionId, dataIni, dataFim);

			if (!Array.isArray(result.results) || result.results.length === 0) {
				throw new Error("Nenhum dado encontrado para exportação.");
			}

			if (exportType === "excel") {
				await exportComissionToExcel(result.results, clientName);
			} else {
				await exportComissionToPDF(result.results, clientName, dataIni, dataFim);
			}

			onClose();
		} catch (err) {
			console.error("Erro ao exportar comissão:", err);
			// toast opcional
		} finally {
			setLoading(false);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ fontWeight: 500 }}>Exportar Comissão</DialogTitle>

			<DialogContent>
				<Typography variant="body2">
					Deseja exportar os dados da comissão de <strong>{clientName}</strong>?
				</Typography>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} disabled={loading}>
					Cancelar
				</Button>

				<Button variant="contained" color="primary" onClick={handleExport} disabled={loading}>
					{loading ? (
						<Stack direction="row" alignItems="center" spacing={1}>
							<CircularProgress size={16} />
							<Typography variant="caption">Exportando...</Typography>
						</Stack>
					) : exportType === "excel" ? (
						"Exportar Excel"
					) : (
						"Exportar PDF"
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
